export default __webpack_public_path__ + "static/media/Group 203.adb15220.png";